<template>
  <div class="andon-head">
    <ul class="list">
      <li class="flex-w1">
        <h2 class="h-title">Andon</h2>
        <div class="chars-area">
          <div class="pic-andon"></div>
        </div>
      </li>
      <li
        v-for="item in clockItem"
        :key="item.id"
        @click="$emit('clickCategory', item, true)"
      >
        <h2 class="h-title">{{ item.title }}</h2>
        <div class="chars-area">
          <clock-chart
            :current-time="currentTime"
            :colors="item.timeArea"
          ></clock-chart>
        </div>
      </li>

      <li class="flex-w2 -px">
        <h2 class="h-title">Summary</h2>
        <div class="chars-area">
          <div @click="$emit('clickAllSummary')">
            <i class="iconfont icon-chart font-big"></i>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  import ClockChart from '@/components/clock-chart'
  import dayjs from 'dayjs'
  export default {
    components: {
      ClockChart,
    },
    props: {
      clockItem: {
        type: Array,
        default() {
          return []
        },
      },
      currentTime: {
        type: Number,
        default: dayjs().valueOf(),
      },
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {},
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .andon-head {
    padding: 10px 0;
    background-color: @subMaster;
    color: @white;
    position: relative;
    height: 150px;
    .font-big {
      font-size: 48px;
    }
    .list {
      display: flex;
      margin: 0;
      padding: 0;
      > li {
        flex: 1;
        border-right: 1px solid @white1;
        box-shadow: 1px 0 0 @black1;
        padding: 0;
        &.flex-w1 {
          flex: 0 0 150px;
        }
        &.flex-w2 {
          flex: 0 0 200px;
        }
        &:not(.flex-w1) {
          cursor: pointer;
          transition: all 0.3s;
          :hover {
            transform: scale(1.01);
          }
        }
      }
      .h-title {
        font-size: 20px;
        text-align: center;
        color: @white;
      }
    }
    .ec-timeAxis {
      top: 0;
    }
    .chars-area {
      position: relative;
      width: 90px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      margin: 0 auto;
      .time-axis-box,
      .ec-timeAxis {
        width: 80px;
        height: 80px;
        right: 3px;
      }
    }
    .pic-andon {
      background: url(~@/assets/i-andon.png) no-repeat center;
      background-size: contain;
      width: 60px;
      height: 60px;
      position: absolute;
      left: 50%;
      margin-left: -30px;
      top: 50%;
      margin-top: -30px;
    }
  }
</style>
